import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

export async function submitInquiry(payload) {
  const { data } = await api.post("/inquiries", payload);
  return data;
}

export async function listInquiries() {
  const { data } = await api.get("/inquiries");
  return data;
}

export async function getFlagshipBull() {
  const { data } = await api.get("/bulls/flagship");
  return data;
}
